/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getActiveBannerProps = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    if (window.bannerProps) {
        return window.bannerProps;
    }
    try {
        const stored = sessionStorage.getItem('activeBannerProps') || localStorage.getItem('activeBannerProps');
        return stored ? JSON.parse(stored) : undefined;
    } catch (e) {
        return undefined;
    }
};

export const setActiveBannerProps = (bannerType, bannerGroup, bannerItemName) => {
    if (typeof window !== 'undefined') {
        const bProps = {
            bannerType: bannerType || '',
            bannerGroup: bannerGroup || '',
            bannerItemName: bannerItemName || '',
        };
        window.bannerProps = bProps;
        try {
            sessionStorage.setItem('activeBannerProps', JSON.stringify(bProps));
            localStorage.setItem('activeBannerProps', JSON.stringify(bProps));
        } catch (e) {
            // ignore
        }
    }
};

export const clearActiveBannerProps = () => {
    if (typeof window !== 'undefined') {
        window.bannerProps = undefined;
        try {
            sessionStorage.removeItem('activeBannerProps');
            localStorage.removeItem('activeBannerProps');
        } catch (e) {
            // ignore
        }
    }
};
